import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'discovery-instructions',
  templateUrl: './instructions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryInstructionsComponent implements OnInit {
  @Input() data;
  @Input() mainTitle;
  @Input() instructions;
  @Output() previousNextInstructionEventEmitter: EventEmitter<object> = new EventEmitter();

  subscription = new Subscription();
  resizeObservable$: Observable<Event>;

  constructor() {}

  ngOnInit(): void {}

  handleSteps(event) {
    this.previousNextInstructionEventEmitter.emit({ status: event, id: this.data?.id });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
